import { LoadState } from "../../constants/enums";
import { ICompanyOutlet, ICompanyOutletState } from "./companyOutlet.types";

export const initialCompanyOutlet: ICompanyOutlet = {
	company_outlet_uuid: "",
	company_outlet_name: "",
	remark: null,
	logo: null,
	policies: null,
	status: "ACTIVE",
	create_ts: "",
	insert_ts: "",
	created_by_uuid: "",
	plan_name: "Starter",
	subscription_start_date: null,
	subscription_end_date: null,
	company_outlet_gstin_number: null,
	company_outlet_email: null,
	company_outlet_phone: null,
};

export const initialCompanyOutletState: ICompanyOutletState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	companyOutlet: {
		data: initialCompanyOutlet,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
